import { db } from "../firebase/firestoreConfig";
import {
  doc,
  where,
  query,
  addDoc,
  deleteDoc,
  collection,
  getDocs,
  Timestamp,
  Query,
} from "firebase/firestore";
import { Transaction } from "../data-types";

const addTransaction = async (row: Transaction) => {
  if ((await queryDuplicate(row)).empty) {
    await addDoc(collection(db, "transactions"), {
      ...row,
    });
    return false;
  } else {
    return true;
  }
};

const queryDuplicate = async (row: Transaction) => {
  const filterDateQuery = query(
    collection(db, "transactions"),
    where("fullDate", "==", row.fullDate)
  );
  const filterDescQuery = query(filterDateQuery, where("desc", "==", row.desc));
  const filterAmountQuery = query(
    filterDescQuery,
    where("amount", "==", row.amount)
  );
  const queriedDoc = await getDocs(filterAmountQuery);
  return queriedDoc;
};

const queryDataFromDate = (fromDate: string, toDate: string) => {
  const fromTimestamp = Timestamp.fromDate(new Date(fromDate));
  const toDateInclusive = new Date(toDate);
  toDateInclusive.setTime(toDateInclusive.getTime() + 23 * 60 * 60 * 1000);
  const toTimestamp = Timestamp.fromDate(new Date(toDateInclusive));
  const fromDateQuery = query(
    collection(db, "transactions"),
    where("fullDate", ">=", fromTimestamp)
  );
  const fromToDateQuery = query(
    fromDateQuery,
    where("fullDate", "<=", toTimestamp)
  );
  return fromToDateQuery;
};

const loadQuery = async (queryRef: Query) => {
  const tableData: Transaction[] = [];
  const rowIds: string[] = [];
  try {
    const data = await getDocs(queryRef);
    data.forEach((row) => {
      tableData.push(row.data() as Transaction);
      rowIds.push(row.id);
    });
    const statusMsg = tableData.length === 0 ? "No Data Found" : "";
    return { tableData, rowIds, statusMsg };
  } catch (err) {
    console.error(err);
    const statusMsg = "Error";
    return { tableData, rowIds, statusMsg };
  }
};

const deleteDocId = async (docId: string) => {
  await deleteDoc(doc(db, "transactions", docId));
  console.log("deleteDocId");
  console.log(docId);
};

export {
  addTransaction,
  queryDuplicate,
  queryDataFromDate,
  loadQuery,
  deleteDocId,
};
